import AssetThumbnail from './AssetThumbnail'

export default AssetThumbnail
